module.exports = __webpack_public_path__ + "static/media/health-insurance.fbab71d7.jpg";